module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAApElEQVR4nO3awQ3CMAAEwUAFVECtqZUK0gE0gLB4OGvBzDeWFXm/t20AAMC/uYwO3Pfj+en7Y78N7/jmvl8zep/rWT/CewLEBIgJEBMgJkBMAAAAAAAAgMnsgiazC1qcADEBYgLEBIgJEBMAAAAAAABgMrugyeyCFidATICYADEBYgLEBAAAAAAAAJjMLmgyu6DFCRATICZATICYADEBAAAATvYCLbcgPRTWO90AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base.png
// module id = 1395
// module chunks = 0